import { Controller } from "@hotwired/stimulus"

// streak-countdown
// ---------------------------------------------------------------
// Live "Resets in 2h 17m / 47m" subtitle for the streak card when
// midnight is < 3h away. Above that threshold, the static "Resets at
// midnight" copy stays as rendered by the server. We deliberately
// avoid showing a live ticker all day — it creates background
// anxiety. Only when the deadline is real do we count down.
//
// Values:
//   • hoursTemplate   — locale string with %{h} %{m} placeholders
//   • minutesTemplate — locale string with %{m} placeholder
//   • thresholdMinutes — switch to live mode when <= this many min remain
export default class extends Controller {
  static targets = ["text"]
  static values = {
    hoursTemplate:    { type: String, default: "" },
    minutesTemplate:  { type: String, default: "" },
    thresholdMinutes: { type: Number, default: 180 }
  }

  connect() {
    if (!this.hasTextTarget) return
    this.tick()
    // Align next firing to the top of the next minute so the visible
    // value flips at the same instant as the wall clock.
    const msToNextMinute = 60_000 - (Date.now() % 60_000)
    this.alignTimer = window.setTimeout(() => {
      this.tick()
      this.interval = window.setInterval(() => this.tick(), 60_000)
    }, msToNextMinute + 50)
  }

  disconnect() {
    window.clearTimeout(this.alignTimer)
    window.clearInterval(this.interval)
  }

  tick() {
    const now = new Date()
    const midnight = new Date(now)
    midnight.setHours(24, 0, 0, 0)
    const totalMinutes = Math.max(0, Math.floor((midnight - now) / 60_000))

    // Above the threshold: leave the server-rendered copy alone.
    if (totalMinutes > this.thresholdMinutesValue) return

    const h = Math.floor(totalMinutes / 60)
    const m = totalMinutes % 60
    const tpl = h > 0 ? this.hoursTemplateValue : this.minutesTemplateValue
    if (!tpl) return
    this.textTarget.textContent = tpl.replace("%{h}", h).replace("%{m}", m)
  }
}
